export const rectsIntersect = (r1, r2) => {
  const r1Right = r1.x + r1.width
  const r1Bottom = r1.y + r1.height
  const r2Right = r2.x + r2.width
  const r2Bottom = r2.y + r2.height

  return r1.x <= r2Right && r1Right >= r2.x && r1.y <= r2Bottom && r1Bottom >= r2.y
}

export const rectContains = (r1, r2) => {
  const r1Right = r1.x + r1.width
  const r1Bottom = r1.y + r1.height
  const r2Right = r2.x + r2.width
  const r2Bottom = r2.y + r2.height

  return r2.x >= r1.x && r2.y >= r1.y && r2Right <= r1Right && r2Bottom <= r1Bottom
}
